export enum BoatType {
    PONTOON = 'Pontoon',
    PONTOON_HYRBID = 'Pontoon Hybrid',
    POWERBOAT = 'Powerboat',
    PWC = 'Personal Watercraft',
}
